if (document.querySelector("textarea[maxlength]")) {
    var textarea = document.querySelector("textarea[maxlength]");
    var charactercount = textarea.parentNode.querySelector("label > small");
    var maxlength = textarea.getAttribute("maxlength");
    textarea.addEventListener("keyup", updateLength);
    textarea.addEventListener("blur", updateLength);
    function updateLength() {
        var characters = textarea.textLength;
        if (characters > maxlength) {
            charactercount.innerHTML = `<span style="color: red">${characters}/${maxlength}</span>`;
        } else if (characters > maxlength * 0.9) {
            charactercount.innerHTML = `<span style="color: orange">${characters}/${maxlength}</span>`;
        } else if (characters > maxlength * 0.5) {
            charactercount.innerHTML = `${characters}/${maxlength}`;
        } else {
            charactercount.innerHTML = `&nbsp;`;
        }
    }

    updateLength();
}
